import React, { useState } from 'react';
import { t } from 'Locale';
import Theme from 'Theme';
import { isTvLikeType, formatTime, getAssetImageUrl } from 'Utils';
import { Device } from 'DeviceUtils';
import { CachedImage } from 'LocalGluons/components/CachedImage';
import { Icon } from 'LocalGluons';
import { CountdownCircleTimer } from 'react-native-countdown-circle-timer';
import { View, Text, ImageBackground } from 'react-native';
import { StyleMap, PlayerData } from 'types';
import LinearGradient from 'react-native-linear-gradient';
import defaultStyles, { imageStyle } from './style';

interface BingeWatchingModalProps {
    style: StyleMap;
    nextBingeItem: PlayerData['item'];
    onItemChange: (item: PlayerData['item']) => void;
    onClose: () => void;
    setLiveLoading: React.Dispatch<React.SetStateAction<boolean>>;
    modalDisplay: 'none' | 'flex';
    changeItem: (newItem: PlayerData['item'], shouldRewindToStart?: boolean) => void;
    setNewCurrentItem: (newCurrentItem: PlayerData['item'], setAlsoAsLiveItem: boolean, rewind: boolean) => void;
    isLiveVOD: boolean;
    onNextPress?: () => void;
}

const BingeWatchingModal = ({
    style,
    nextBingeItem,
    onItemChange,
    onClose,
    setLiveLoading,
    modalDisplay,
    changeItem,
    setNewCurrentItem,
    isLiveVOD,
    onNextPress
}: BingeWatchingModalProps) => {
    const getMetaData = nextBingeItem.getMetaData();
    const metaDataDetail = Object.values(getMetaData)[1];
    const nextItemAssetImage = { uri: getAssetImageUrl(nextBingeItem, 'PREVIEW') };
    const nextItemChannelLogo = { uri: metaDataDetail?.channelLogoUrl };
    const nextItemChannelName = metaDataDetail?.channelname;
    const nextItemTitle = nextBingeItem?.getTitle();
    const nextItemSeason = `${t('COMMON.SEASON')} ${metaDataDetail?.seasonNumber}`;
    const nextItemEpisode = `${t('COMMON.EPISODE')} ${metaDataDetail?.episodeNumber}`;
    const nextItemDetail = `${nextItemSeason}, ${nextItemEpisode}`;
    const nextProgramStart = formatTime(metaDataDetail?.start);
    const nextProgramEnd = formatTime(metaDataDetail?.end);
    const infoContainerStyles = isTvLikeType(nextBingeItem)
        ? defaultStyles.itemInfoContainer
        : defaultStyles.iteminfoContainerEpisode;

    const nextProgramDetail = `${t('COMMON.TODAY')} | ${nextProgramStart} - ${nextProgramEnd}`;

    const playNextItem = () => {
        if (isLiveVOD) return;
        onCircleComplete();
    };

    const onCircleComplete = () => {
        onClose();
        setLiveLoading(true);
        // onItemChange(nextBingeItem);
        if (typeof onNextPress === 'function') {
            onNextPress();
        } else {
            setNewCurrentItem(nextBingeItem, false, true);
        }
    };

    const playIcon = () => <Icon name="play_arrow_player" onPress={playNextItem} />;

    const returnUpNextTitle = () => (
        <Text style={defaultStyles.upNextTitle}>{t('COMMON.PROMO_UP_NEXT')}</Text>
    );

    const programInfo = () => (
        <>
            {/* {Device.isTablet && returnUpNextTitle()} */}
            <View style={defaultStyles.channelInfoContainer}>
                <CachedImage
                    source={nextItemChannelLogo}
                    resizeMode="cover"
                    style={defaultStyles.channelIconStyle}
                />
                {/* {Device.isTablet && (
                    <Text style={defaultStyles.nextItemChannelName}>{nextItemChannelName}</Text>
                )} */}
            </View>
            <View style={defaultStyles.channelIconLine} />
            <Text style={defaultStyles.nextItemTitle} numberOfLines={1} ellipsizeMode='tail'>{nextItemTitle}</Text>
            <Text style={defaultStyles.nextItemDetail}>{nextProgramDetail}</Text>
        </>
    );

    const episodeInfo = () => (
        <>
            {/* {Device.isTablet && returnUpNextTitle()} */}
            <Text style={[defaultStyles.nextItemTitle, { marginTop: 22, marginBottom: 10 }]}
                numberOfLines={1}>
                {nextItemTitle}
            </Text>
            <Text style={defaultStyles.nextItemDetail}>{nextItemDetail}</Text>
        </>
    );

    const returnNextItemDetail = () => {
        if (isTvLikeType(nextBingeItem)) {
            return programInfo();
        }
        return episodeInfo();
    };

    return (
        <View style={[defaultStyles.container, style]}>
            <LinearGradient
                start={{ x: 0, y: 1 }}
                end={{ x: 0, y: 0.2 }}
                colors={['rgba(0, 0, 0, 0.9)', 'rgba(0, 0, 0, 0.7)', 'rgba(0, 0, 0, 0)']}
                style={defaultStyles.gradient}
            >
                <View style={defaultStyles.backgroundContainer} />
                <View style={defaultStyles.innerContainer}>
                    <View style={defaultStyles.nextItemContainer}>
                        <View style={defaultStyles.nextItemImage}>
                            {(Device.isPhone || Device.isTablet) && returnUpNextTitle()}
                            <View style={defaultStyles.itemImageContainer}>
                                <ImageBackground
                                    resizeMode="cover"
                                    source={nextItemAssetImage}
                                    style={defaultStyles.itemImageBackground}
                                    imageStyle={imageStyle}
                                >
                                    <View style={defaultStyles.countdownCircle}>
                                        <CountdownCircleTimer
                                            size={50}
                                            strokeWidth={3}
                                            trailStrokeWidth={0}
                                            isPlaying
                                            duration={5}
                                            colors={Theme.primaryTextColor}
                                            isSmoothColorTransition
                                            onComplete={onCircleComplete}
                                        >
                                            {playIcon}
                                        </CountdownCircleTimer>
                                    </View>
                                </ImageBackground>
                            </View>
                        </View>
                        <View style={infoContainerStyles}>{returnNextItemDetail()}</View>
                    </View>
                </View >
            </LinearGradient >
        </View >
    );
};

export default BingeWatchingModal;
